import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "en-power-switcher"
};
const _hoisted_2 = { class: "power-trigger hover:bg-en-blue-100" };
const _hoisted_3 = { class: "power-trigger-name pa-1" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($setup.props.enPowerAccounts.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode($setup["DropdownMenuRoot"], {
                open: $setup.powerMenuOpen,
                "onUpdate:open": _cache[0] || (_cache[0] = ($event) => (($setup.powerMenuOpen) = $event)),
                modal: false
            }, {
                default: _withCtx(() => [
                    _createVNode($setup["DropdownMenuTrigger"], { "as-child": "" }, {
                        default: _withCtx(() => [
                            _createElementVNode("button", _hoisted_2, [
                                _createElementVNode("span", _hoisted_3, _toDisplayString($setup.currentName), 1 /* TEXT */),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["power-arrows", { open: $setup.powerMenuOpen }])
                                }, [
                                    _createVNode($setup["EnIcon"], {
                                        class: "arrow up text-en-blue-500",
                                        size: "16"
                                    }, {
                                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                _createTextVNode("mdi-chevron-up", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode($setup["EnIcon"], {
                                        class: "arrow down text-en-blue-500",
                                        size: "16"
                                    }, {
                                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                _createTextVNode("mdi-chevron-down", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ], 2 /* CLASS */)
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode($setup["DropdownMenuPortal"], null, {
                        default: _withCtx(() => [
                            _createVNode($setup["DropdownMenuContent"], {
                                side: "bottom",
                                "side-offset": 4,
                                align: "start",
                                "body-lock": false,
                                class: "z-2500 min-w-36 rounded-lg border border-[#d6dce0] bg-white p-1.5 shadow-[0_6px_15.3px_0_rgba(13,48,72,0.09)] origin-[--reka-dropdown-menu-content-transform-origin] data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-1 data-[side=top]:slide-in-from-bottom-1"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.enPowerAccounts, (account) => {
                                        return (_openBlock(), _createBlock($setup["DropdownMenuItem"], {
                                            key: account.Id,
                                            class: "block px-2 py-1.5 text-sm rounded-md cursor-pointer outline-none text-[#0d3048] hover:bg-[#ecf0f2]",
                                            onClick: ($event) => ($setup.selectAccount(account))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(account.Name), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["open"])
        ]))
        : _createCommentVNode("v-if", true);
}
